// src/data/navTopics.js
//
// The sub-topics that live under a sidebar section, in one place. These lists
// were hardcoded three times in Sidebar.jsx and a fourth time in App.jsx, which
// is how a topic ends up hidden in a menu but still reachable by link.
//
// Ids are route ids and content keys — they persist (see CLAUDE.md, "rename
// labels, never keys"). Change a label freely; never an id.

export const NAV_TOPIC_GROUPS = {
    'mental-health': [
        { id: 'anxiety', label: 'Anxiety' },
        { id: 'depression', label: 'Depression' },
        { id: 'adhd', label: 'ADHD' },
        { id: 'eating-disorders', label: 'Eating Disorders' },
        { id: 'addictions', label: 'Addictions' },
        { id: 'ptsd-trauma', label: 'PTSD & Trauma' },
        { id: 'gambling', label: 'Gambling' }
    ],
    'mental-performance': [
        { id: 'resilience', label: 'Resilience' },
        { id: 'focus', label: 'Focus' },
        { id: 'confidence', label: 'Confidence' },
        { id: 'motivation', label: 'Motivation' },
        { id: 'self-awareness', label: 'Self-Awareness' },
        { id: 'self-discipline', label: 'Self-Discipline' },
        { id: 'adaptability', label: 'Adaptability' },
        { id: 'nutrition-hydration', label: 'Nutrition & Hydration' },
        { id: 'pain-injury', label: 'Pain & Injury' }
    ]
};

// Platform-level age gate, independent of any org setting: nobody under 18 is
// shown these topics, on any surface. An org allowlist can narrow this further
// but can never widen it. (Eating disorders and trauma joined the list on
// 2026-10-06 when minors gained the athlete surface.)
export const MINOR_EXCLUDED_TOPIC_IDS = ['addictions', 'gambling', 'eating-disorders', 'ptsd-trauma'];
export const TEEN_EXCLUDED_TOPIC_IDS = MINOR_EXCLUDED_TOPIC_IDS;

export const topicIds = (groupId) => (NAV_TOPIC_GROUPS[groupId] || []).map((t) => t.id);

// Which section a topic id belongs to, or null if it is not a sub-topic.
export const parentOfTopic = (tabId) =>
    Object.keys(NAV_TOPIC_GROUPS).find((g) => NAV_TOPIC_GROUPS[g].some((t) => t.id === tabId)) || null;
